import { postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";

//  Add Banner
export const AddBannerService = async (data,isEdited) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: API_URLS.ADMIN + `banner-image/${isEdited===true?"update":"create"}`,
      data: data,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
 //   console.log("ResAdd", response);
    return response;
  } catch (error) {
    console.error("Error in AddBannerService:", error);
    throw error;
  }
};
export const deleteBannerService = async (bannerId) => {
  try {
    const response = await postRequest({
      url: API_URLS.ADMIN + "banner-image/delete",
      data: {
        'banner_id': bannerId
      },
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;

  } catch (error) {
    return error;
  }
}


// ENd


// Fetch Login Banner
export const fetchBanner = async (page = 1) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}banner-image/report?page=${page}`,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
  //  console.log("ResGet", response);
    return response;
  } catch (error) {
    console.error(error);
  }
};
// ENd



// Edit Banner
export const editBannerDetails = async ({ banner_id }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: API_URLS.ADMIN + "banner-image/edit",
      data: { banner_id },
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    //console.log(response);
    return response;
  } catch (error) {
    console.error("Error in fetching Edit Banner", error);
    throw error;
  }
};
// ENd



// Update Banner
export const updateBannerDetails = async ({ payload, banner_id }) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}banner-image/update`,
      data: { banner_id, ...payload },
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
  //  console.log(response);
    return response;
  } catch (error) {
    console.error("Error in Updating Banner", error);
    throw error;
  }
};
// ENd
